var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024.0013 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1011.512 460.534L627.735 76.757c-26.862-26.862-72.794-7.837-72.794 30.153v170.763C310.7 287.825 95.273 454.127 27 690.8 4.2 769.8-1.49 834.816.307 904.794c.226 8.215.284 10.586.284 12.31 0 43.33 57.125 59.043 79.286 21.81 47.506-79.82 101.463-141.5 160.573-187.09C347.314 669.41 458.57 645.54 554.94 655.18v219.287c0 37.99 45.93 57.015 72.793 30.153L1011.51 520.84c16.654-16.65 16.654-43.652.002-60.304zM640.224 771.517V618.612c0-19.535-13.274-36.57-32.215-41.348-5.19-1.31-13.81-3.024-25.502-4.66-120.79-16.9-261.115 9.092-394.14 111.688-32.722 25.237-63.884 54.566-93.32 88.16l.65-3.415c3.4-17.508 7.755-35.587 13.24-54.598 60.866-210.995 259.918-356.612 480.346-351.86 3.726.065 5.1.095 6.826.155 24.112.832 44.112-18.49 44.112-42.617V209.856l280.83 280.83L640.225 771.52z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.0f4232a353cea64620ff165b9f912be6.svg";
export { ForwardRef as ReactComponent };